import React from 'react'

const info = () => {
  return (
    <div className="about__info grid">
      <div className="about__box">
      <i className='bx bx-award about__icon'></i>
        <h3 className="about__title">Experience</h3>
        <span className="about__subtitle">1+ Year of Working</span>
      </div>

      <div className="about__box">
      <i className='bx bx-briefcase-alt about__icon'></i>

        <h3 className="about__title">Completed</h3>
        <span className="about__subtitle">20+ projects</span>
      </div>

      <div className="about__box">
      <i className='bx bx-data about__icon' ></i>
        <h3 className="about__title">Algorithms</h3>
        <span className="about__subtitle">700+ Problems</span>
      </div>
    </div>
  )
}

export default info